import { render, staticRenderFns } from "./ImportarArchivo.vue?vue&type=template&id=f5edcd78"
import script from "./ImportarArchivo.vue?vue&type=script&lang=js"
export * from "./ImportarArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports